module.exports = __webpack_public_path__ + "static/creator-tokens-background-de07092850e12c41f0ef75b71c2a3a7d.webp";